import {useCallback, useState} from "react";
import BillingSetting from "./billing-setting";

function unwrapEntity(value) {
    let entity = value;
    while (entity?.data && !entity.documentId && !entity.id) entity = entity.data;
    if (!entity || (!entity.documentId && !entity.id)) return null;

    const normalized = {...entity, ...(entity.attributes || {})};
    const bankAccounts = normalized.bankAccounts?.data || normalized.bankAccounts || [];
    return {
        ...normalized,
        bankAccounts: Array.isArray(bankAccounts)
            ? bankAccounts.map((account) => ({...account, ...(account.attributes || {})}))
            : [],
    };
}

export function useBillingSetting() {
    const [billingSetting, setBillingSetting] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const getBillingSettings = useCallback(async () => {
        const model = new BillingSetting();
        setLoading(true);
        setError(null);
        try {
            const data = await model.getAll({});
            const setting = unwrapEntity(data);
            setBillingSetting(setting);
            return setting;
        } catch (requestError) {
            if (requestError?.response?.status === 404) {
                setBillingSetting(null);
                return null;
            }
            setError(requestError);
            throw requestError;
        } finally {
            setLoading(false);
        }
    }, []);

    const saveBillingSettings = useCallback(async (payload) => {
        const model = new BillingSetting();
        setError(null);
        try {
            const data = await model.save(payload);
            const setting = unwrapEntity(data);
            setBillingSetting(setting);
            return setting;
        } catch (requestError) {
            setError(requestError);
            throw requestError;
        }
    }, []);

    return {
        billingSetting,
        loading,
        error,
        getBillingSettings,
        saveBillingSettings,
    };
}
